import create from 'zustand';
import { devtools } from 'zustand/middleware';
import { produce } from 'immer';
import { undoMiddleware } from 'zundo';
import shallow from 'zustand/shallow';
// Immer middleware
const immer = (config) => (set, get, api) => config((fn, replace, actionName) => {
    set(produce(fn), replace, actionName);
}, get, api);
// TODO: Deprecrate this function and rely on `createTypedStore` instead for all functions (TICKET #: https://indicodata.atlassian.net/browse/UI-990)
export function createStore(store) {
    if (process.env.NODE_ENV === 'development') {
        return create(devtools(immer(store)));
    }
    return create(immer(store));
}
// TODO: Rename to `createStore` once current `createStore` is deprecated (TICKET #: https://indicodata.atlassian.net/browse/UI-990)
export function createTypedStore(store) {
    if (process.env.NODE_ENV === 'development') {
        return create(devtools(immer(store)));
    }
    return create(immer(store));
}
/**
 * Works just like createStore(), but includes undo/redo functionality.
 *
 * @see {@link https://github.com/charkour/zundo}
 */
export function createStoreWithUndo(store, options) {
    if (process.env.NODE_ENV === 'development') {
        return create(undoMiddleware(devtools(immer(store)), options));
    }
    return create(undoMiddleware(immer(store), options));
}
export { shallow };
//# sourceMappingURL=zustand.js.map